import 'react-international-phone/style.css';

import {
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import {
  defaultCountries,
  FlagImage,
  parseCountry,
  usePhoneInput,
} from 'react-international-phone';

const MuiPhone = ({ value, onChange, ...restProps }) => {
  const {
    inputValue, handlePhoneValueChange, inputRef, country, setCountry,
  } = usePhoneInput({
    defaultCountry: 'us',
    value,
    countries: defaultCountries,
    onChange: (data) => {
      onChange(data);
    },
  });

  const isRequired = restProps.inputProps?.required;
  const label = isRequired ? 'Phone number *' : 'Phone number';

  return (
    <TextField
      variant="outlined"
      label={label}
      error={restProps?.error}
      color="primary"
      placeholder="Phone number"
      value={inputValue}
      style={{
        marginTop: '10px',
        marginBottom: '5px',
        width: '50%',
      }}
      onChange={handlePhoneValueChange}
      type="tel"
      inputRef={inputRef}
      InputProps={{
        required: true,
        startAdornment: (
          <InputAdornment
            position="start"
            style={{ marginRight: '2px', marginLeft: '-8px' }}
          >
            <Select
              MenuProps={{
                style: {
                  height: '300px',
                  width: '360px',
                  top: '10px',
                  left: '-34px',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
              }}
              sx={{
                width: 'max-content',
                // Remove default outline (display only on focus)
                fieldset: {
                  display: 'none',
                },
                '&.Mui-focused:has(div[aria-expanded="false"])': {
                  fieldset: {
                    display: 'block',
                  },
                },
                // Update default spacing
                '.MuiSelect-select': {
                  padding: '8px',
                  paddingRight: '24px !important',
                },
                svg: {
                  right: 0,
                },
              }}
              value={country.iso2}
              onChange={(e) => setCountry(e.target.value)}
              renderValue={(selectedValue) => (
                <FlagImage iso2={selectedValue} style={{ display: 'flex' }} />
              )}
            >
              {defaultCountries.map((c) => {
                const parsedCountry = parseCountry(c);
                if (parsedCountry === undefined) {
                  return null;
                }
                return (
                  <MenuItem key={parsedCountry.iso2} value={parsedCountry.iso2}>
                    <FlagImage
                      iso2={parsedCountry.iso2}
                      style={{ marginRight: '8px' }}
                    />
                    <Typography marginRight="8px">{parsedCountry.name}</Typography>
                    <Typography color="gray">+{parsedCountry.dialCode}</Typography>
                  </MenuItem>
                );
              })}
            </Select>
          </InputAdornment>
        ),
      }}
      {...restProps}
    />
  );
};

MuiPhone.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

MuiPhone.defaultProps = {
  value: '',
};

export default MuiPhone;
